import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {GenerateSegments, GetSegments} from '../../shared/api/definitions/ai';
import {TaskStatusQueryKeys} from './tasks';

export function useGenerateSegments() {
  const queryClient = useQueryClient();
  return useApiMutation(GenerateSegments, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('generateSegments'),
      });
    },
  });
}

export const useGetSegments = createApiQuery(
  GetSegments,
  ({previousResponseId}) => ['getSegments', previousResponseId]
);
